module.exports = __webpack_public_path__ + "static/media/projects.8703ce11.jpg";